import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmExperienceSupportWebsiteOverviewRoute: InvariantJiraRoute = {
	name: 'csm-experience-support-website-overview',
	path: '/jira/customer-service-management/experiences/:projectKey/settings/:helpCenterId/support-website/overview',
	exact: true,
};
